// extracted by mini-css-extract-plugin
module.exports = {"DialogTitle":"Dialog_DialogTitle__1Il-B"};